import { createCircleMarker, getCircleMarkerSize, getCircleMarkerSizeWithoutShadow } from './svgMarkerComponents';

const innerDiameter = 16;
export const size = getCircleMarkerSize(innerDiameter);
export const svgSizeWithoutShadow = getCircleMarkerSizeWithoutShadow(innerDiameter);
const endSvg = createCircleMarker({ imageName: 'end', innerDiameter, innerFill: '#1A2B16' });

export default endSvg;
